import { PlatformPromos } from '../../../../hooks/useFetchPlatformPromos/types';
import { UserProfileBonusStatus } from '../../../../types.__generated__';
import { ParsedPromo, PromoTypes } from '../../../Layout/Promotions/types';
import { compareWithPromoType } from '../../../Layout/Promotions/utils';

export const evaluatePromosWithPlatform = (
  promo: ParsedPromo,
  platformPromosObj: PlatformPromos
): ParsedPromo | undefined => {
  const promoType = promo.promoType;
  const platformPromos = platformPromosObj?.platformPromos;
  const { magicXPromos, depositPromos, rewardsPromos, userTags } = platformPromos;

  const isMagicX = compareWithPromoType(promoType, PromoTypes.WAGER_AND_GET);
  const isRewards =
    compareWithPromoType(promoType, PromoTypes.FREE_BET) || compareWithPromoType(promoType, PromoTypes.FREE_SPINS);
  const isDeposit = compareWithPromoType(promoType, PromoTypes.DEPOSIT_MATCH);
  const isNetwork = compareWithPromoType(promoType, PromoTypes.NETWORK);

  const magicXPromo = isMagicX && magicXPromos.find((magicXPromo) => promo.magicXSlug === magicXPromo.magicXSlug);
  const rewardsPromo = isRewards && rewardsPromos.find((rewardsPromo) => promo.bonusId === rewardsPromo.bonusId);
  const depositPromo = isDeposit && depositPromos.find((depositPromo) => promo.bonusId === depositPromo.bonusId);
  const networkPromo = isNetwork && promo;

  if (depositPromo)
    depositPromo.status = userTags?.find((userTag) => promo.tagId === userTag)
      ? UserProfileBonusStatus.Available
      : UserProfileBonusStatus.Claimed;

  const platformPromo = magicXPromo || depositPromo || rewardsPromo || networkPromo;

  if (platformPromo)
    return {
      ...promo,
      ...platformPromo,
    };
};

export const isAnyPlatformPromoReceived = (platformPromos?: PlatformPromos): boolean | undefined => {
  const receivedPlatfromPromos = platformPromos?.platformPromos;

  return receivedPlatfromPromos && Object.values(receivedPlatfromPromos).some((promo) => promo?.length);
};
